import { ValidateUserArgs } from 'types/api/arguments/validate-user-args'
import { api } from '@marketplace-web/core-api/core-api-client-data'

export const validateUser = ({ user }: ValidateUserArgs) => api.post('/users/validations', { user })
